// Copyright TraderEvolution Global LTD. 2017-2026. All rights reserved.
//
// Routes manager extracted from DataCache.
import { Route } from './cache/Route';
export class Routes {
    constructor() {
        this.routes = new Map();
        this.infoRoutes = new Map();
    }
    clear() {
        this.routes.clear();
        this.infoRoutes.clear();
    }
    getTradeRoutes() {
        return Array.from(this.routes.values());
    }
    addRoute(message) {
        if (!(message === null || message === void 0 ? void 0 : message.RouteId)) {
            return false;
        }
        if (message.IsInfo && !message.IsTradable) {
            return this.processInfoRoute(message);
        }
        return this.processTradeRoute(message);
    }
    getRouteByName(name) {
        var _a;
        return (_a = this.routes.get(name)) !== null && _a !== void 0 ? _a : null;
    }
    getRouteByTextName(name) {
        for (const route of this.routes.values()) {
            if (route.Name === name) {
                return route;
            }
        }
        return null;
    }
    getRouteById(id) {
        var _a;
        const tradeRoute = this.routes.get(id);
        if (tradeRoute) {
            return tradeRoute;
        }
        return (_a = this.infoRoutes.get(id)) !== null && _a !== void 0 ? _a : null;
    }
    getRouteByTextId(id) {
        const routeId = Number(id);
        if (!Number.isFinite(routeId)) {
            return null;
        }
        return this.getRouteById(routeId);
    }
    getValidRouteIDs(tradeRouteIDs, infoRouteIDs) {
        const routeIDs = new Set([...tradeRouteIDs, ...infoRouteIDs]);
        // removing an info route if it's related to the trade route.
        for (const routeID of routeIDs) {
            const route = this.routes.get(routeID);
            if ((route === null || route === void 0 ? void 0 : route.IsTradable) && route.RouteId !== route.QuoteRouteId) {
                const infoRoute = this.infoRoutes.get(route.QuoteRouteId);
                if (infoRoute === null || infoRoute === void 0 ? void 0 : infoRoute.IsInfo) {
                    routeIDs.delete(infoRoute.RouteId);
                }
            }
        }
        return routeIDs;
    }
    processInfoRoute(message) {
        const existingRoute = this.infoRoutes.get(message.RouteId);
        if (existingRoute) {
            existingRoute.UpdateByMessage(message);
            return false;
        }
        this.infoRoutes.set(message.RouteId, new Route(message));
        return true;
    }
    processTradeRoute(message) {
        const existingRoute = this.routes.get(message.RouteId);
        if (existingRoute) {
            existingRoute.UpdateByMessage(message);
            return false;
        }
        this.routes.set(message.RouteId, new Route(message));
        return true;
    }
}
